import config from '@/config'

export const uri = ({ service, path }: { service: string; path: string }) =>
  `${service}/api/${config.service.version}/${path}`
